import axios from 'axios';
import useUserStore from '../store/useUserStore';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_V1_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 10000,
});

axiosInstance.interceptors.request.use(
    (config) => {
        const { user } = useUserStore.getState();
        // backend-v1's /adminpanel routes are SuperAdmin-only (protect + authorize).
        if (user?.token) {
            config.headers.set('Authorization', `Bearer ${user.token}`);
        }
        if (user?.db) {
            config.headers.set('db', user.db);
        }
        return config;
    },
    (error) => Promise.reject(error)
);
export { axiosInstance };
